// import React, { useState } from "react";
// import { useAuth } from "../../../context/AuthContext";
// import { PROGRAM_CATEGORIES } from "../../../data/tutorPrograms";
// import ProgramForm from "../forms/ProgramForm";
// import { updateUserProfile } from "../../../utils/userApi";
// import { toast } from "react-hot-toast";

// const ProgramSection = () => {
//   const { user, updateUser } = useAuth();

//   const [isEditing, setIsEditing] = useState(false);
//   const [editing, setEditing] = useState(false);
//   const [isSaving, setIsSaving] = useState(false);
//   const toggleEdit = () => setIsEditing(!isEditing);

  

//   const [formData, setFormData] = useState({
//     programType: user?.programType || "",
//     mainProgram: user?.mainProgram || "",
//     selectedCourses: user?.selectedCourses || [],
//     hourlyRate: user?.hourlyRate || "",
//     ratePeriod: user?.ratePeriod || "hour",
//     location: user?.location || {},
//   });

//   const toggleCourse = (course) => {
//     setFormData((prev) => {
//       const exists = prev.selectedCourses.includes(course);

//       return {
//         ...prev,
//         selectedCourses: exists
//           ? prev.selectedCourses.filter((c) => c !== course)
//           : prev.selectedCourses.length < 5
//             ? [...prev.selectedCourses, course]
//             : prev.selectedCourses,
//       };
//     });
//   };

//   const handleSave = async () => {
//     try {
//       setIsSaving(true);

//       const res = await updateUserProfile(formData, user.token);

//       updateUser(res.user);

//       setEditing(false);


//     } catch (err) {

//     } finally {
//       setIsSaving(false);
//     }
//   };

//   return (
//     <div className="about-wrapper">
//       <div className="account-profile-card">
//         {/* HEADER */}
//         <div className="account-profile-header">
//           <div>
//             <h3>My Program</h3>
//             <p className="section-subtext">
//               Manage your program activities here
//             </p>
//           </div>

//           {!isEditing && (
//             <button className="edit-btn" onClick={toggleEdit}>
//               ✏️ Edit
//             </button>
//           )}
//         </div>

//         {/* CONTENT */}
//         {isEditing ? (
//           <ProgramForm onCancel={toggleEdit} />
//         ) : (
//           <div className="program-content">
//             {/* PROGRAM TYPE */}
//             <div className="program-block">
//               <h4>Program Type</h4>
//               <div className="tag-group">
//                 {user?.programType?.split(",")?.map((item, i) => (
//                   <span key={i} className="tag">
//                     {item}
//                   </span>
//                 ))}
//               </div>
//             </div>

//             {/* CATEGORY */}
//             <div className="program-block">
//               <h4>Courses Category</h4>
//               <div className="tag-group">
//                 {/* {user?.mainProgram?.map((course, i) => ( */}
//                 <span className="tag">{user?.mainProgram}</span>
//                 {/* ))} */}
//                 {/* {user?.mainProgram} */}
//               </div>
//             </div>

//             {/* COURSES OFFERED */}
//             <div className="program-block">
//               <h4>Courses Offer</h4>
//               <div className="tag-group">
//                 {user?.selectedCourses?.map((course, i) => (
//                   <span key={i} className="tag alt">
//                     {course}
//                   </span>
//                 ))}
//               </div>
//             </div>

//             <div className="info-item">
//               <span>Pricing</span>
//               <p>
//                 ₦{user?.hourlyRate || "-"} / {user?.ratePeriod || "hour"}
//               </p>
//             </div>

//             {/* ADDRESS */}
//             <div className="program-block">
//               <h4>Address</h4>
//               <p>{user?.location?.address || "No address provided"}</p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>

//   );
// };

// export default ProgramSection;


import React, { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import ProgramForm from "../forms/ProgramForm";
import { PROGRAM_CATEGORIES } from "../../../data/tutorPrograms";
import { formatRate } from "../../../utils/formatters";

// Harmonized to 3 modes (online/hybrid/physical) — the old keys below are
// kept as a display fallback for any record not yet migrated, see
// scripts/migrateTeachingModes.js.
const teachingModeLabels = {
  online: "Online",
  hybrid: "Hybrid",
  physical: "Physical",
  "online-live": "Online",
  "online-self-paced": "Online",
  "in-person-private": "Physical",
  "in-person-classroom": "Physical",
  others: "Physical",
};

const ProgramSection = ({ setStatusModal }) => {
  const { user, updateUser } = useAuth();
  const [isEditing, setIsEditing] = useState(false);

  const toggleEdit = () => setIsEditing(!isEditing);

  // New Data Structure
  const selectedCategories = user?.selectedCategories || [];
  const categoryDetails = user?.categoryDetails || {};
  const teachingModes = user?.teachingModes || [];

  return (
    <div className="about-wrapper">
      <div className="account-profile-card">
        {/* HEADER */}
        <div className="account-profile-header">
          <div>
            <h3>My Programs & Teaching</h3>
            <p className="section-subtext">Courses and rates you offer</p>
          </div>

          {!isEditing && (
            <button className="edit-btn" onClick={toggleEdit}>
              ✏️ Edit
            </button>
          )}
        </div>

        {/* VIEW MODE */}
        {!isEditing ? (
          <div className="program-content">
            {/* TEACHING MODES */}
            {teachingModes.length > 0 && (
              <div className="program-block">
                <h4>Teaching Modes</h4>
                <div className="tag-group">
                  {teachingModes.map((mode, i) => (
                    <span key={i} className="tag">
                      {teachingModeLabels[mode] || mode.replace(/-/g, " ")}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* CATEGORIES & COURSES */}
            {selectedCategories.length > 0 ? (
              selectedCategories.map((groupName) => {
                const details = categoryDetails[groupName] || {};
                const courses = details.courses || [];

                return (
                  <div key={groupName} className="program-block">
                    <h4>{groupName}</h4>

                    <div className="tag-group" style={{ marginBottom: "12px" }}>
                      {courses.map((course, i) => (
                        <span key={i} className="tag alt">
                          {course}
                        </span>
                      ))}
                    </div>

                    {details.rate && (
                      <div className="info-item">
                        <span>Pricing</span>
                        <p>{formatRate(details.rate, details.period || "hour")}</p>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <p>No program categories added yet.</p>
            )}

            {/* LOCATION */}
            <div className="program-block">
              <h4>Address</h4>
              <p>{user?.location?.address || "No address provided"}</p>
            </div>
          </div>
        ) : (
          /* EDIT MODE */
          <ProgramForm onCancel={toggleEdit} />
        )}
      </div>
    </div>
  );
};

export default ProgramSection;